<template>
  <div class="chat button-icon" @click="openJivo()">
    <div class="chat-control">
      <div class="icon-chat text-color-purple icon--medium"></div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    openJivo () {
      // eslint-disable-next-line camelcase,no-undef
      if (jivo_api) {
      // eslint-disable-next-line camelcase,no-undef
        jivo_api.open()
      }
    }
  }
}
</script>
